import { FormControl, FormGroup } from '@angular/forms';

import { MultiPolygon } from '@connect-services/client/sdk/api';

export enum FieldInterventionModalCloseModeEnum {
    FIELD_INTERVENTION_AREA_SELECTION = 'field_intervention_area_selection',
    SAVE = 'save',
}

export type FieldInterventionModalResult = {
    creationEditionForm?: FieldInterventionCreationEditionForm;
    mode: FieldInterventionModalCloseModeEnum;
};

export class FieldInterventionCreationEditionForm extends FormGroup<{
    description: FormControl<string | null>;
    fieldInterventionArea: FormControl<MultiPolygon | null>;
    name: FormControl<string>;
    scheduledEndDate: FormControl<Date | null>;
}> {}

export type FieldInterventionCreateEditModalData = {
    description?: string;
    fieldInterventionArea?: MultiPolygon | null;
    name?: string;
    scheduledEndDate?: Date;
    title: string;
};
